<template>
<div>
  <Form ref="data" :model="data" :rules="ruleInline" inline>
  <h3>个人信息</h3>
  <div class="container">
    <div class="user-layout">
      <Row :gutter="16" type='flex' align='middle'>
        <Col span="3">账号:</Col>
        <Col span="3"><img v-if="headimgurl != ''" :src="headimgurl" width="60px" height="60px"/></Col>
        <Col span="3" v-if="headimgurl == ''"><Icon type="ios-contact" size="58"/></Col>
        <Col span="5">
          {{nickname}}
        </Col>
        <!-- <Col span="13"><Button type="primary" @click="logout">退出</Button></Col> -->
      </Row>
    </div>
    <div class="user-layout">
      <Row :gutter="24">
        <Col span="3">{{type == 'organization' && categoryType == '1'?'单位名称':'姓名'}}:</Col>
        <Col span="8">
          <FormItem prop="name">
              <Input type="text" v-model="data.name" placeholder='请输入名称'/>
          </FormItem>
        </Col>
      </Row>
    </div>
    <template v-if="invidiInfo">
      <div class="user-layout">
        <Row :gutter="24">
          <Col span="3">手机号:</Col>
          <Col span="8">
            <FormItem prop="mobile">
              <Input type="text" v-model="data.mobile" maxlength="11" placeholder="请输入手机号码" />
            </FormItem>
          </Col>
        </Row>
      </div>
     <div class="user-layout">
        <Row :gutter="24">
          <Col span="3">邮箱:</Col>
          <Col span="8">
            <FormItem prop="email">
              <Input type="text" v-model="data.email" placeholder="请输入邮箱" />
            </FormItem>
          </Col>
        </Row>
      </div>
    </template>
    <template v-if="companyInfo">
      <div class="user-layout">
        <Row :gutter="24">
          <Col span="3">手机号:</Col>
          <Col span="8">
            <FormItem prop="mobile">
              <Input type="text" v-model="data.mobile" maxlength="11" placeholder="请输入手机号码" />
            </FormItem>
          </Col>
        </Row>
      </div>
      <div class="user-layout">
        <Row :gutter="24">
          <Col span="3">邮箱:</Col>
          <Col span="8">
            <FormItem prop="email">
              <Input type="text" v-model="data.email"  />
            </FormItem>
          </Col>
        </Row>
      </div>
      <div class="user-layout">
        <Row :gutter="24">
          <Col span="3">单位介绍信:</Col>
          <!-- http://localhost:8083/openapi/image/download/sdfsdfsdfdd.jpg -->
          <Col span="8"><img :src="this.apiUrl+data.companyUrl" width="300" height="300"/></Col>
        </Row>
      </div>
    </template>
  </div>
  <template v-if="guideInfo">
    <h3>导游信息</h3>
    <div class="container">
      <div class="user-layout">
      <Row :gutter="24">
        <Col span="3">导游证号:</Col>
        <Col span="8">{{data.guideNo}}</Col>
      </Row>
    </div>
    <div class="user-layout">
      <Row :gutter="24">
        <Col span="3">邮箱:</Col>
        <Col span="8">
          <FormItem prop="email">
            <Input type="text" v-model="data.email"  />
          </FormItem>
        </Col>
      </Row>
    </div>
    <div class="user-layout">
      <Row :gutter="24">
        <Col span="3">证件照片:</Col>
        <!-- http://localhost:8083/openapi/image/download/sdfsdfsdfdd.jpg -->
        <Col span="8"><img :src="this.apiUrl+guideImgUrl" width="300" height="300"/></Col>
      </Row>
    </div>
    </div>
  </template>
  <div class="update-btn">
    <Button type="primary" @click="handleUpdate('data')">修改信息</Button>
  </div>
  </Form>
</div>
</template>

<script>
import Vue from 'vue'
import { httpAction } from '@/api/manage'
import api from '@/api'
import { isIDCard, isMobile, isFullName,isCompanyName } from '@/util/reg'
export default {
  inject: ['reload'],
  data () {
    const validateName = (rule, value, callback) => {
      let errorStr = ''
      if(this.type == 'organization'){
        if (!isCompanyName(value)) {
          errorStr = '请填写正确的单位名称!'
        } else {
          callback()
        }
      }else{
         if (!isFullName(value)) {
          errorStr = '请填写正确的姓名!'
        } else {
          callback()
        }
      }
      return callback(new Error(errorStr))
    }
    const validateMobile = (rule, value, callback) => {
      let errorStr = ''
      if (!isMobile(value)) {
        errorStr = '请填写有效的电话号码!'
      } else {
        callback()
      }
      return callback(new Error(errorStr))
    }
    const validateIdCard = (rule, value, callback) => {
      let errorStr = ''
      if (!isIDCard(value)) {
        errorStr = '请填写有效的证件号码'
      } else {
        callback()
      }
      return callback(new Error(errorStr))
    }
    return {
      guideImgUrl: '',
      data: {},
      invidiInfo:false,
      guideInfo: false,
      companyInfo:false,
      categoryType:'',
      type:'',
      nickname: '',
      headimgurl: '',
      ruleInline: {
        name: [
          { validator: validateName, trigger: 'blur' },
          { type: 'string', max: 25, message: '不能超过25个汉字', trigger: 'blur' }
        ],
        mobile: [
          { validator: validateMobile, trigger: 'blur' }
        ],
        idCard: [
          { validator: validateIdCard, trigger: 'blur' }
        ],
        email: [
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' },
          { type: 'string', max: 50, message: '不能超过50个字符', trigger: 'blur' }
        ]
      },
      // url: {
      //   list: '/openapi/user/select',
      //   update: '/openapi/user/update'
      // }
    }
  },
  mounted () {
    this.getList()
    this.nickname = Vue.ls.get('nickname')
    this.headimgurl = Vue.ls.get('headimgurl')
    this.categoryType = Vue.ls.get('type')
  },
  methods: {
    async getList () {
      const obj = { userId: '1' }
      const res = await httpAction(api.userSelect, 'post', obj)
      this.data = res.data
      console.log(this.data)
      // this.type = res.data.type
      if (this.categoryType === '0') {
        this.invidiInfo = true
        return
      }
      const groupRes = await httpAction(api.groupSelect, 'post', obj)
      const result = groupRes.data.groupAttrInfos
      for (const item of result) {
        if (item.attributeKey === 'idCardUrl') {
          this.guideImgUrl = item.attributeValue
        }
      }
      this.type = groupRes.data.type || ''
      if (!groupRes) {
        this.invidiInfo = true
        return
      }

      if (this.type === 'guide') {
        this.guideInfo = true
      }
      if (this.type === 'organization') {
        this.companyInfo = true
      }

      for (const item of result) {
        if (item.attributeKey === 'guideNo') {
          this.data.guideNo = item.attributeValue
        }
        if (item.attributeKey === 'idCardUrl') {
          this.data.idCardUrl = item.attributeValue
        }
        if (item.attributeKey === 'companyUrl') {
          this.data.companyUrl = item.attributeValue
        }
        if (item.attributeKey === 'headImageUrl') {
          this.data.headImageUrl = item.attributeValue
        }
        if (item.attributeKey === 'nickname') {
          this.data.nickname = item.attributeValue
        }
      }
    },
    // 退出登录
    logout () {
      this.$Modal.confirm({
        title: '是否确认退出登录？',
        onOk: () => {
          if (Vue.ls.get('token')) {
            Vue.ls.remove('token')
            Vue.ls.remove('type')
            Vue.ls.remove('headimgurl')
            Vue.ls.remove('nickname')
            Vue.ls.remove('group')
            Vue.ls.remove('temporary')
            this.$router.push('/')
            this.isShow = false
            this.$Message.success('退出成功')
          } else {
            this.$Message.error('请您先登录')
          }
        },
        onCancel: () => {
        }
      })
    },
    // 修改个人信息
    handleUpdate (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$Modal.confirm({
            title: '是否确认修改个人信息？',
            onOk: async () => {
              const param = {
                name: this.data.name,
                mobile: this.data.mobile,
                email: this.data.email,
                idCard: this.data.idCard
              }
              const res = await httpAction(api.userUpdate, 'post', param)
              if (res.status === '0') {
                this.$Message.success('修改成功')
                this.$store.dispatch('setUserName', this.data.name)
                this.getList()
              }
            },
            onCancel: () => {}
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.container{
  padding:40px;
}
.user-layout{
  margin-bottom: 10px;
}
.update-btn{
  text-align: right;
}
</style>
